module.exports = __webpack_public_path__ + "static/media/coursera.21a9081b.jpg";